import { FileText, File, Download } from "lucide-react";
import toast from "react-hot-toast";
import { download } from "../../../services/exportService";

const ExportButtons = ({ model, className = "" }) => {
  const buttons = [
    {
      label: "CSV",
      format: "csv",
      icon: <FileText className="w-4 h-4 mr-2" />,
      color: "bg-[#00A86B] hover:bg-[#008C5A]",
    },
    {
      label: "Excel",
      format: "excel",
      icon: <File className="w-4 h-4 mr-2" />,
      color: "bg-emerald-600 hover:bg-emerald-700",
    },
    {
      label: "PDF",
      format: "pdf",
      icon: <Download className="w-4 h-4 mr-2" />,
      color: "bg-red hover:bg-red-700",
    },
    {
      label: "JSON",
      format: "json",
      icon: <Download className="w-4 h-4 mr-2" />,
      color: "bg-purple-600 hover:bg-purple-700",
    },
  ];

  const handleExport = async (format) => {
    if (!model) {
      toast.error("Model is required for export");
      return;
    }

    const toastId = toast.loading(
      `Generating ${format.toUpperCase()} export...`
    );

    try {
      // Use your existing download API function
      await download({
        model: model,
        format: format,
      });

      toast.success(`${format.toUpperCase()} exported successfully`, {
        id: toastId,
      });
    } catch (error) {
      console.error("Export error:", error);
      toast.error(error.message || "Export failed", { id: toastId });
    }
  };

  return (
    <div className={`flex flex-wrap mt-4 gap-2 ${className}`}>
      {buttons.map((button) => (
        <button
          key={button.label}
          onClick={() => handleExport(button.format)}
          className={`flex items-center ${button.color} text-white px-3 py-2 text-sm rounded-md font-medium transition-colors duration-200 shadow-sm hover:shadow-md`}
          aria-label={`Export as ${button.label}`}
        >
          {button.icon}
          {button.label}
        </button>
      ))}
    </div>
  );
};

export default ExportButtons;
